import { render, staticRenderFns } from "./allocate-promotion-dialog.vue?vue&type=template&id=0d1aa801&scoped=true"
import script from "./allocate-promotion-dialog.vue?vue&type=script&lang=js"
export * from "./allocate-promotion-dialog.vue?vue&type=script&lang=js"
import style0 from "./allocate-promotion-dialog.vue?vue&type=style&index=0&id=0d1aa801&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1aa801",
  null
  
)

export default component.exports